var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { getHeaders } from "../utils/apiUtils";
import { fetchAllPages, MAX_LIST_LIMIT } from "../utils/fetchAllPages";
export var fetchPublisherPrefixes = function (kyInstance, filters) { return __awaiter(void 0, void 0, void 0, function () {
    var query, _a, offset, _b, limit, searchParams, response, data;
    var _c, _d, _e;
    return __generator(this, function (_f) {
        switch (_f.label) {
            case 0:
                query = filters.query, _a = filters.offset, offset = _a === void 0 ? 0 : _a, _b = filters.limit, limit = _b === void 0 ? MAX_LIST_LIMIT : _b;
                searchParams = new URLSearchParams();
                searchParams.set("query", query || "cql.allRecords=1");
                searchParams.set("offset", String(offset));
                searchParams.set("limit", String(limit));
                return [4 /*yield*/, kyInstance.get("publisher-prefixes", {
                        searchParams: searchParams,
                        headers: getHeaders(),
                    })];
            case 1:
                response = _f.sent();
                if (!response.ok) {
                    throw new Error("Fetch error: ".concat(response.status, " ").concat(response.statusText));
                }
                return [4 /*yield*/, response.json()];
            case 2:
                data = (_f.sent());
                return [2 /*return*/, {
                        items: (_d = (_c = data.items) !== null && _c !== void 0 ? _c : data.publisherPrefixes) !== null && _d !== void 0 ? _d : [],
                        totalRecords: (_e = data.totalRecords) !== null && _e !== void 0 ? _e : 0,
                    }];
        }
    });
}); };
/**
 * Loads every publisher prefix matching a CQL query (a bounded set, e.g. the
 * prefixes of one publisher), page by page within the backend list limit.
 *
 * @param kyInstance okapi ky instance
 * @param query CQL search clause without sorting — a stable sort is added for paging
 * @returns all matching prefixes
 */
export var fetchAllPublisherPrefixes = function (kyInstance, query) { return __awaiter(void 0, void 0, void 0, function () {
    var items;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetchAllPages(function (offset, limit) {
                    return fetchPublisherPrefixes(kyInstance, {
                        query: "".concat(query, " sortBy value id"),
                        offset: offset,
                        limit: limit,
                    });
                })];
            case 1:
                items = _a.sent();
                return [2 /*return*/, { items: items, totalRecords: items.length }];
        }
    });
}); };
/**
 * Searches publisher prefixes for the identifier report autocomplete.
 * The backend matches the typed text against the full, normalized identifier
 * (international prefix + agency prefix + publisher value with hyphens removed) as well as
 * against the publisher name, so both the complete identifier (e.g. "978-80-7050") and its
 * trailing publisher value (e.g. "7050") return the matching records.
 */
export var searchPublisherPrefixesByIdentifier = function (kyInstance, filters) { return __awaiter(void 0, void 0, void 0, function () {
    var search, publisherSourceId, _a, offset, _b, limit, searchParams, response, data;
    var _c, _d, _e;
    return __generator(this, function (_f) {
        switch (_f.label) {
            case 0:
                search = filters.search, publisherSourceId = filters.publisherSourceId, _a = filters.offset, offset = _a === void 0 ? 0 : _a, _b = filters.limit, limit = _b === void 0 ? 100 : _b;
                searchParams = new URLSearchParams();
                searchParams.set("identifierSearch", search);
                if (publisherSourceId) {
                    searchParams.set("publisherSourceId", publisherSourceId);
                }
                searchParams.set("offset", String(offset));
                searchParams.set("limit", String(limit));
                return [4 /*yield*/, kyInstance.get("publisher-prefixes", {
                        searchParams: searchParams,
                        headers: getHeaders(),
                    })];
            case 1:
                response = _f.sent();
                if (!response.ok) {
                    throw new Error("Fetch error: ".concat(response.status, " ").concat(response.statusText));
                }
                return [4 /*yield*/, response.json()];
            case 2:
                data = (_f.sent());
                return [2 /*return*/, {
                        items: (_d = (_c = data.items) !== null && _c !== void 0 ? _c : data.publisherPrefixes) !== null && _d !== void 0 ? _d : [],
                        totalRecords: (_e = data.totalRecords) !== null && _e !== void 0 ? _e : 0,
                    }];
        }
    });
}); };
export var fetchPublisherPrefixById = function (kyInstance, id) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                return [4 /*yield*/, kyInstance.get("publisher-prefixes/".concat(id), {
                        headers: getHeaders(),
                    })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Fetch error: ".concat(response.statusText));
                }
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _a.sent()];
            case 3:
                error_1 = _a.sent();
                console.error("Error fetching publisherPrefix by ID:", error_1);
                throw error_1;
            case 4: return [2 /*return*/];
        }
    });
}); };
export var resolvePublisherPrefix = function (kyInstance, productNumber) { return __awaiter(void 0, void 0, void 0, function () {
    var searchParams, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                searchParams = new URLSearchParams();
                searchParams.set("productNumber", productNumber);
                return [4 /*yield*/, kyInstance.get("publisher-prefixes/resolve", {
                        searchParams: searchParams,
                        headers: getHeaders(),
                    })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Resolve error: ".concat(response.statusText));
                }
                return [2 /*return*/, response.json()];
        }
    });
}); };
export var createPublisherPrefix = function (kyInstance, publisherPrefix) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                return [4 /*yield*/, kyInstance.post("publisher-prefixes", {
                        json: publisherPrefix,
                        headers: getHeaders(),
                    })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Create error: ".concat(response.statusText));
                }
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _a.sent()];
            case 3:
                error_2 = _a.sent();
                console.error("Error creating publisherPrefix:", error_2);
                throw error_2;
            case 4: return [2 /*return*/];
        }
    });
}); };
export var transferPublisherPrefix = function (kyInstance, id, targetPublisherId) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, kyInstance.post("publisher-prefixes/".concat(id, "/transfer"), {
                    json: { targetPublisherId: targetPublisherId },
                    headers: getHeaders(),
                })];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response.json()];
        }
    });
}); };
export var declareLastUsedNumber = function (kyInstance, id, request) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                return [4 /*yield*/, kyInstance.post("publisher-prefixes/".concat(id, "/last-used-number"), {
                        json: request,
                        headers: getHeaders(),
                    })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Declare error: ".concat(response.statusText));
                }
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _a.sent()];
            case 3:
                error_3 = _a.sent();
                console.error("Error declaring last used number:", error_3);
                throw error_3;
            case 4: return [2 /*return*/];
        }
    });
}); };
export var deletePublisherPrefix = function (kyInstance, id) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_4;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, kyInstance.delete("publisher-prefixes/".concat(id), {
                        headers: getHeaders(),
                    })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Delete error: ".concat(response.statusText));
                }
                return [3 /*break*/, 3];
            case 2:
                error_4 = _a.sent();
                console.error("Error deleting publisherPrefix:", error_4);
                throw error_4;
            case 3: return [2 /*return*/];
        }
    });
}); };
